function isFieldValueEmpty(value: unknown): boolean {
  if (value === null || value === undefined || value === '') return true;

  if (typeof value === 'object' && !Array.isArray(value)) {
    return Object.values(value).every(
      (prop) => prop === null || prop === undefined || prop === '',
    );
  }

  return false;
}

export default isFieldValueEmpty;